const Spinner = ({ grow = false }) => {
  return (
    <div className="text-center">
      <div className={grow ? "spinner-grow" : "spinner-border"}></div>
    </div>
  );
};

export default Spinner;
